"use strict";
/* global ENV_CONFIG */
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.logBI = void 0;
// If you want to see detailed information in console about all BI, set to true
var IS_EXPAND_LOG = false;
function logBI(_a) {
    var eventName = _a.eventName, event = _a.event, isDeprecated = _a.isDeprecated;
    if (!ENV_CONFIG.logBiSend) {
        return;
    }
    var output = JSON.stringify(event, null, 2).replace(/"/g, '');
    var deprecationMessage = isDeprecated ? '[deprecated logger] ' : '';
    var systemEventName = event.eventName ? "(".concat(event.eventName, ")") : '';
    var logMethod = IS_EXPAND_LOG ? 'group' : 'groupCollapsed';
    console[logMethod]("%c".concat(deprecationMessage, "%cBI %c").concat(eventName).concat(systemEventName, ":").concat(event.evid), 'color: #f27052;', 'color: #65c888;', 'color: auto; font-weight: normal;');
    console.log(output);
    console.groupEnd();
}
exports.logBI = logBI;
//# sourceMappingURL=index.js.map